
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Menu, X } from 'lucide-react';
import { Sheet, SheetTrigger, SheetContent } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { NavigationList } from './NavigationList';
import { NavItemType } from './types';

interface MobileSidebarProps {
  navItems: NavItemType[];
  isActive: (path: string) => boolean;
  onSignOut: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function MobileSidebar({ navItems, isActive, onSignOut, open, setOpen }: MobileSidebarProps) {
  return (
    <div className="lg:hidden border-b bg-background w-full sticky top-0 z-30">
      <div className="flex h-14 items-center px-4 justify-between">
        <Link to="/cms" className="flex items-center font-semibold">
          Agam CMS
        </Link>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="z-50">
              <Menu size={20} />
              <span className="sr-only">Toggle navigation</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="w-64 p-0 z-50 bg-background">
            <div className="flex h-14 items-center border-b px-4">
              <Link to="/cms" onClick={() => setOpen(false)} className="flex items-center font-semibold">
                Agam CMS
              </Link>
              <Button
                variant="ghost"
                size="icon"
                className="ml-auto"
                onClick={() => setOpen(false)}
              >
                <X size={18} />
                <span className="sr-only">Close</span>
              </Button>
            </div>
            <ScrollArea className="h-[calc(100vh-3.5rem)]">
              <NavigationList 
                navItems={navItems}
                isActive={isActive}
                onItemClick={() => setOpen(false)}
                onSignOut={onSignOut}
              />
            </ScrollArea>
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
}
